import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 1,
    width: 300,
    minWidth: 300,
    margin: theme.spacing(4),
    flex: '0 0 auto',
    height: 'calc(100vh - 128px)',
  },
}));

const PageActions = (props) => {
  const { children } = props;
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};

PageActions.propTypes = {
  children: PropTypes.node.isRequired,
};

PageActions.defaultProps = {};

export default PageActions;
